module.exports = __webpack_public_path__ + "static/media/item_2_2.2016b694.png";